import { CLEAR, CLICK, INIT, SET_LOADING, UPDATE_OPTIONS } from "./constants";
import { IInitLinkButtonAction, ILinkButtonClearAction, ILinkButtonClickAction, ILinkButtonSetLoadingAction, IUpdateLinkButtonOptionsAction } from "./types";

/** Akce, která se vyvolá při inicializace link buttonu */
export const createInitLinkButtonAction = (dataKey: string, url: string, params: string[], functions: string[]): IInitLinkButtonAction => ({
    type: INIT,
    payload: {
        url,
        params,
        functions,
        isLoading: false,
    },
    meta: {
        dataKey,
    },
});

/** Akce, která se vyvolá při změně actualObjectu */
export const createUpdateLinkButtonOptionsAction = (dataKey: string, instanceID?: string): IUpdateLinkButtonOptionsAction => ({
    type: UPDATE_OPTIONS,
    payload: {
        instanceID,
    },
    meta: {
        dataKey,
    },
});

/** Akce, která se vyvolá při kliknutí na tlačítko */
export const createLinkButtonClickAction = (dataKey: string): ILinkButtonClickAction => ({
    type: CLICK,
    meta: {
        dataKey,
    },
});

/** Akce starající se o smazání instance Link Buttonu ze storu. */
export const createClearLinkButtonAction = (dataKey: string): ILinkButtonClearAction => ({
    type: CLEAR,
    meta: {
        dataKey,
    },
});

/** Nastaví indikátor načítání pro daný klíč
 * @param dataKey Klíč konkrétního LinkButtonu
 * @param isLoading Stav načítání
 */
export const createSetLoadingAction = (dataKey: string, isLoading: boolean): ILinkButtonSetLoadingAction => ({
    type: SET_LOADING,
    payload: {
        isLoading,
    },
    meta: {
        dataKey,
    },
});
